import { RootState } from '@/App/store';

export const selectSeoDefaults = (state: RootState) => state.config.seo.defaults;
